import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable()
export class UpdateApplication {

    constructor(private updates: SwUpdate) {        
    }

    public checkForAppUpdates() {
        console.log('Checking for updates');
        this.updates.available.subscribe(event => {
            console.log('Applying updates');
            this.updates.activateUpdate().then(() => {
                console.log('Reload after updates');
                document.location.reload();
            });
        });

        // this.updates.activated.subscribe(event => {
        // });

        this.updates.checkForUpdate();
    }

}